import { Route } from "react-router-dom";
import { ProtectedRoute } from "./routes/ProtectedRoute.jsx";
import { ROLES } from "@/config/roles.js";
import i18n from "@/i18n.js";
import TemplateAdmin from "@/layout/TemplateAdmin.jsx";
import UsersCompanies from "@/pages/shared/UsersCompanies.jsx";

import RequestTicketDetail from "@/pages/user/RequestTickets/RequestTicketDetail.jsx";
import CompanyContacts from "@/pages/user/Contacts/CompanyContacts.jsx";
import CompanyContactsCreate from "@/pages/user/Contacts/CompanyContactsCreate.jsx";
import CompanyContactsEdit from "@/pages/user/Contacts/CompanyContactsEdit.jsx";
import CompanyContactsShow from "@/pages/user/Contacts/CompanyContactsShow.jsx";
import Bills from "@/pages/user/Bills/Bills.jsx";
import RequestTickets from "@/pages/user/RequestTickets/RequestTickets.jsx";
import ShowTicket from "@/pages/user/RequestTickets/ShowTicket.jsx";
import BuyPackage from "@/pages/user/BuyPackages.jsx";
import PaymentResult from "@/pages/user/Payments/PaymentResult.jsx";
import CreateBill from "@/pages/user/Bills/CreateBill.jsx";
import ShowBill from "@/pages/user/Bills/ShowBill.jsx";
import FirstCompany from "@/pages/user/Onboarding/FirstCompany.jsx";
import MyCompanies from "@/pages/user/MyCompanies.jsx";
import CompanyEdit from "@/pages/user/CompanyEdit.jsx";
import CompanyShow from "@/pages/user/CompanyShow.jsx";

const UserRoutes = (
  <Route
    element={<ProtectedRoute allowedRoles={[ROLES.USER, ROLES.SUPER_ADMIN]} />}
  >
    <Route
      path="/bills"
      element={
        <TemplateAdmin
          title={i18n.t("page.requestedBills")}
          content={<Bills />}
        />
      }
    />
    <Route
      path="/bills/create"
      element={
        <TemplateAdmin
          title={i18n.t("page.requestBill")}
          content={<CreateBill />}
        />
      }
    />
    <Route
      path="/bills/:billingId/show"
      element={
        <TemplateAdmin
          title={i18n.t("page.billDetail")}
          content={<ShowBill />}
        />
      }
    />
    <Route
      path="/{id}/users-companies"
      element={
        <TemplateAdmin
          path="/users-companies"
          title={i18n.t("page.accountData")}
          content={<UsersCompanies />}
        />
      }
    />
    <Route
      path="/tickets/:companyId/:id/review"
      element={
        <TemplateAdmin
          title={"Detalle del Request ticket"}
          content={<RequestTicketDetail />}
        />
      }
    />
    <Route
      path={"/contacts"}
      element={
        <TemplateAdmin
          title={i18n.t("page.clientsToBill")}
          breadcrumb={i18n.t("page.clients")}
          content={<CompanyContacts />}
        />
      }
    />
    <Route
      path={"/contacts/create"}
      element={
        <TemplateAdmin
          title={i18n.t("page.clientCreate")}
          content={<CompanyContactsCreate />}
        />
      }
    />
    <Route
      path={"/contacts/:contactId/edit"}
      element={
        <TemplateAdmin
          title={i18n.t("page.clientEdit")}
          content={<CompanyContactsEdit />}
        />
      }
    />
    <Route
      path={"/contacts/:contactId/show"}
      element={
        <TemplateAdmin
          title={i18n.t("page.clientShow")}
          content={<CompanyContactsShow />}
        />
      }
    />
    <Route
      path={"/request_tickets"}
      element={
        <TemplateAdmin
          title={"Detalle de paquetes para comprar"}
          content={<RequestTickets />}
        />
      }
    />
    <Route
      path={"/request_tickets/:requestTicketId/show"}
      element={
        <TemplateAdmin
          title={"Detalle de paquetes para comprar"}
          content={<ShowTicket />}
        />
      }
    />
    <Route
      path={"/buy_package"}
      element={
        <TemplateAdmin
          title={"Selecciona el paquete para comprar"}
          content={<BuyPackage />}
        />
      }
    />
    <Route
      path={"/buy_package/result"}
      element={
        <TemplateAdmin
          title={"Resultado del pago"}
          content={<PaymentResult />}
        />
      }
    />
    <Route
      path={"/onboarding/company"}
      element={
        <TemplateAdmin
          title={i18n.t("ui.generateAccount")}
          content={<FirstCompany />}
        />
      }
    />
    <Route
      path={"/my-companies"}
      element={
        <TemplateAdmin
          title={i18n.t("page.account")}
          content={<MyCompanies />}
        />
      }
    />
    <Route
      path={"/companies/:id/edit"}
      element={
        <TemplateAdmin
          title={i18n.t("page.accountEdit")}
          content={<CompanyEdit />}
        />
      }
    />
    <Route
      path={"/companies/:id"}
      element={
        <TemplateAdmin
          title={i18n.t("page.accountShow")}
          content={<CompanyShow />}
        />
      }
    />
  </Route>
);

export default UserRoutes;
